import { render, staticRenderFns } from "./SoilScans.vue?vue&type=template&id=2ca267cd&scoped=true&"
import script from "./SoilScans.vue?vue&type=script&lang=js&"
export * from "./SoilScans.vue?vue&type=script&lang=js&"
import style0 from "./SoilScans.vue?vue&type=style&index=0&id=2ca267cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca267cd",
  null
  
)

export default component.exports